import { useEffect } from 'react';

/**
 * A custom React hook that sets the document's title to the specified value.
 *
 * @param title - The title to set for the document. This will update the browser's tab title.
 *
 * @example
 * ```tsx
 * usePageTitle("Dashboard");
 * ```
 *
 * @remarks
 * This hook uses the `useEffect` hook to update the document title whenever the `title` value changes.
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
